import { Design } from '../../../types';

const defaultGlobalLoopHandling = {
  inARow: '',
  lastLocalChange: 0,
  xAndOut: ''
};

const defaultIntentHandling = {
  inARowLimit: 3,
  inARowLimitLastLocalChange: 0,
  xAndOutLimit: 3,
  xAndOutLimitLastLocalChange: 0
};

/**
 * Normalize @see Design settings not part of @see DesignRootSettings due to being too old.
 *
 * @note @see normalizeRootSettings normalizes @see DesignRootSettings.
 */
export function normalizeLegacySettings(serialized: Design) {
  serialized.globalLoopHandling = {
    ...defaultGlobalLoopHandling,
    ...serialized.globalLoopHandling
  };

  serialized.intentHandling = {
    ...defaultIntentHandling,
    ...serialized.intentHandling
  };

  serialized.languages ??= [];
  serialized.languages = serialized.languages.map((language) => {
    return {
      ...language,
      voice: language.voice || ''
    };
  });
}
